/** Centered loading indicator with frame-prefetch progress (DESIGN.md §6, §9 Loading state). */
export class LoadingCard {
  readonly element: HTMLElement;
  private readonly textEl: HTMLSpanElement;

  constructor() {
    this.element = document.createElement("div");
    this.element.className = "loading-card card";
    this.element.setAttribute("role", "status");
    this.element.setAttribute("aria-live", "polite");

    const spinner = document.createElement("div");
    spinner.className = "spinner";
    spinner.setAttribute("aria-hidden", "true");

    this.textEl = document.createElement("span");
    this.textEl.className = "loading-card__text";
    this.textEl.textContent = "Wczytywanie danych radaru…";

    this.element.append(spinner, this.textEl);
  }

  setProgress(loaded: number, total: number): void {
    this.textEl.textContent = `Wczytywanie klatek ${loaded}/${total}`;
  }

  setMessage(message: string): void {
    this.textEl.textContent = message;
  }

  show(): void {
    this.element.hidden = false;
  }

  hide(): void {
    this.element.hidden = true;
  }
}
